import type { ErrorDescriptor, ErrorOverrides } from '@if/mui'
import type { AxiosError } from 'axios'

interface BusinessExceptionBody {
  message?: string
  type?: string
}

const NO_CONTRACT_FOR_PROVINCE_AND_LANGUAGE = 'noContractForProvinceAndLanguage'

export const getBusinessErrorMessage = (descriptor: Pick<ErrorDescriptor, 'raw'>): string | undefined => {
  const body = (descriptor.raw as AxiosError<BusinessExceptionBody> | undefined)?.response?.data
  return body?.type === 'BusinessValidationError' ? body.message : undefined
}

export const businessErrorRegistry: ErrorOverrides = {
  unknown: (descriptor, t) =>
    getBusinessErrorMessage(descriptor) === NO_CONTRACT_FOR_PROVINCE_AND_LANGUAGE
      ? { role: 'contextual', message: t('common.errors.noContractForProvinceAndLanguage') }
      : undefined,
}
